// hamburger nav

const breakpoint = 1300;
const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);

let controller = null;

function setupMobile() {
	if (controller) controller.abort();
	controller = new AbortController();
	const { signal } = controller;

	const body = document.querySelector("body");
	const button = document.querySelector(".menu-button");
	const navBar = document.querySelector("header .menu");
	const header = document.querySelector("header");
	const parent = document.querySelectorAll(".menu-item-has-children >a");
	const arrow = document.querySelectorAll(".menu-item-has-children >svg");

	button.onclick = function toggleMenu() {
		if (navBar.matches(".show")) {
			body.style.overflow = "visible";
			navBar.classList.remove("anim");
			setTimeout(function () {
				navBar.classList.remove("show");
			}, 400);
			button.classList.remove("menu-close");
			header.classList.remove("show");
		} else {
			body.style.overflow = "hidden";
			navBar.classList.add("show");
			setTimeout(function () {
				navBar.classList.add("anim");
			}, 100);

			button.classList.add("menu-close");
			header.classList.add("show");

			// Hides dropdown when menu is hidden
			parent.forEach(function (ele) {
				ele.classList.remove("show-ul");
			});
		}
	};

	parent.forEach(function (ele) {
		ele.addEventListener("click", function (e) {
			e.preventDefault();
			if (ele.parentNode.classList.contains("show-ul")) {
				window.location = e.target.href;
			} else {
				ele.parentNode.classList.add("show-ul");
			}
		}, { signal });
	});

	arrow.forEach(function (ele) {
		ele.addEventListener("click", function (e) {
			e.preventDefault();
			if (ele.parentNode.classList.contains("show-ul")) {
				ele.parentNode.classList.remove("show-ul");
			} else {
				ele.parentNode.classList.add("show-ul");
			}
		}, { signal });
	});
}

function setupDesktop() {
	if (controller) controller.abort();
	controller = new AbortController();

	const body = document.querySelector("body");
	const button = document.querySelector(".menu-button");
	const navBar = document.querySelector("header .menu");
	const header = document.querySelector("header");

	body.style.overflow = "";
	navBar.classList.remove("show", "anim");
	button.classList.remove("menu-close");
	header.classList.remove("show");
	const { signal } = controller;

	const links = document.querySelectorAll(".menu-item-has-children >a");
	const descendants = document.querySelectorAll(
		" .menu-item-has-children > ul > li > a"
	);

	descendants.forEach((descendant) => {
		descendant.addEventListener("focus", () => {
			const grandParent =
				descendant.parentElement.parentElement.parentElement;
			console.log(grandParent);
			grandParent.classList.add("show-ul");
		}, { signal });

		descendant.addEventListener("blur", () => {
			const grandParent =
				descendant.parentElement.parentElement.parentElement;
			grandParent.classList.remove("show-ul");
		}, { signal });
	});

	links.forEach((link) => {
		link.addEventListener("focus", () => {
			link.parentNode.classList.add("show-ul");
		}, { signal });

		link.addEventListener("blur", () => {
			link.parentNode.classList.remove("show-ul");
		}, { signal });
	});
}

function handleBreakpoint() {
	if (mql.matches) {
		setupMobile();
	} else {
		setupDesktop();
	}
}

window.addEventListener("load", handleBreakpoint);
mql.addEventListener("change", handleBreakpoint);
